module.exports = __webpack_public_path__ + "img/estructuras.b6188dca.jpg";